var _rect, _rect2, _line, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMicroDeposit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  fill: "none",
  viewBox: "0 0 72 72",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "#FFF",
  rx: 36
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 28,
  width: 28,
  height: 20,
  rx: 3,
  stroke: "#008AEA",
  strokeWidth: 2.2,
  fill: "none"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 22,
  y1: 34,
  x2: 50,
  y2: 34,
  stroke: "#008AEA",
  strokeWidth: 2.2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 38,
  y: 38,
  width: 8,
  height: 4,
  rx: 1,
  fill: "#008AEA"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMicroDeposit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/micro_deposit.1eac2dcd939cbbf8ebfe177de609bb55.svg";